import Container from '@framework/di/Container';
import { loadModules } from '@framework/di/loadModules';
import { useDIContext } from './DIContext';
import createContainer, { PageRenderingStateValue } from './createContainer';
import { cache } from 'react';
import isServer from '@framework/router/Next/isServer';
/**
 * @DI_CONFIGURATION_MODULES — per-app tsconfig path alias, resolved to an app-specific module set.
 *
 * The only way to inject app-specific container modules into shared Framework code
 * without depending on _app.tsx or RootLayout.
 *
 * In App Router server components may skip re-running RootLayout as an optimisation,
 * while React.cache is scoped to a single request — so the cached container won't survive.
 * This alias allows re-initialising container modules independently of the layout lifecycle.
 * It also enables container creation inside Server Actions, where no layout runs at all.
 */
import { serverContainerModules } from '@DI_CONFIGURATION_MODULES';

const serverContainer = cache(() => {
  const container = createContainer(PageRenderingStateValue.ServerSideRendering);
  loadModules(container, serverContainerModules);
  return container;
});

export const getContainer = (): Container => {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useDIContext();
  } catch (e) {
    if (!isServer()) {
      throw e;
    }
    return serverContainer();
  }
};
